(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  root.classList.add("fdf-js");

  function initReveal(section) {
    var revealItems = section.querySelectorAll("[data-fdf-reveal]");

    revealItems.forEach(function (item, index) {
      item.style.setProperty("--fdf-delay", Math.min(index * 110, 440) + "ms");
    });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(function (item) {
        item.classList.add("fdf-is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("fdf-is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function isInteractive(target) {
    return Boolean(target.closest("a, button, input, select, textarea, summary"));
  }

  function setCardState(card, expanded, focusTarget) {
    var toggle = card.querySelector("[data-fdf-toggle]");
    var back = card.querySelector("[data-fdf-back]");
    var frontLinks = card.querySelectorAll(".fdf-card__face--front a");
    var backControls = card.querySelectorAll(".fdf-card__face--back a, .fdf-card__face--back button");

    card.classList.toggle("fdf-card--flipped", expanded);

    if (toggle) {
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.tabIndex = expanded ? -1 : 0;
    }

    frontLinks.forEach(function (link) {
      link.tabIndex = expanded ? -1 : 0;
    });

    backControls.forEach(function (control) {
      control.tabIndex = expanded ? 0 : -1;
    });

    if (back) {
      back.tabIndex = expanded ? 0 : -1;
    }

    if (focusTarget === "front" && toggle) {
      toggle.focus({ preventScroll: true });
    }

    if (focusTarget === "back" && back) {
      back.focus({ preventScroll: true });
    }
  }

  function initFlipCards(section) {
    section.querySelectorAll("[data-fdf-card]").forEach(function (card) {
      if (card.dataset.fdfCardInitialized === "true") {
        return;
      }

      var toggle = card.querySelector("[data-fdf-toggle]");
      var back = card.querySelector("[data-fdf-back]");
      var returnButton = card.querySelector("[data-fdf-return]");

      card.dataset.fdfCardInitialized = "true";
      setCardState(card, false);

      if (toggle) {
        toggle.addEventListener("click", function () {
          setCardState(card, true, "back");
        });
      }

      if (back) {
        back.addEventListener("click", function (event) {
          if (isInteractive(event.target)) {
            return;
          }

          setCardState(card, false, "front");
        });

        back.addEventListener("keydown", function (event) {
          if ((event.key === "Enter" || event.key === " ") && !isInteractive(event.target)) {
            event.preventDefault();
            setCardState(card, false, "front");
          }
        });
      }

      if (returnButton) {
        returnButton.addEventListener("click", function () {
          setCardState(card, false, "front");
        });
      }

      card.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && card.classList.contains("fdf-card--flipped")) {
          setCardState(card, false, "front");
        }
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.fdfInitialized === "true") {
      return;
    }

    section.dataset.fdfInitialized = "true";
    initReveal(section);
    initFlipCards(section);
  }

  function initAll() {
    document.querySelectorAll("[data-fdf-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector("[data-fdf-section]"));
  });
})();
